module.exports = __webpack_public_path__ + "static/media/leathercraft-modelling-jspoons-closeup.7f31dbdc.webp";